import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IFilterModel } from 'src/app/shared/models/filter-model';
import { IFilterData } from 'src/app/shared/models/filter-model';
import { SendShippingEmailRequest, ShippingAccounting } from '../../../domain/entities/shipping-accounting.entity';
import { ShippingAccountingFacade } from '../../facades/shipping-accounting.facade';

@Component({
  selector: 'app-shipping-accounting-container',
  templateUrl: './shipping-accounting-container.component.html',
  styleUrls: ['./shipping-accounting-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShippingAccountingContainerComponent implements OnInit {
  readonly vm$ = this.facade.vm$;
  selectedForEmail: ShippingAccounting | null = null;
  readonly listData: IFilterData[] = [{ id: 1, name: new Date() }];

  constructor(private readonly facade: ShippingAccountingFacade) {}

  ngOnInit(): void {
    this.facade.load();
  }

  onFilter(filters: IFilterModel[]): void {
    this.facade.filterBy(filters);
  }

  onLoadMore(): void {
    this.facade.loadMore();
  }

  onDownloadCsv(item: ShippingAccounting): void {
    this.facade.downloadCsv(item.professionalId);
  }

  onSendEmailClick(item: ShippingAccounting): void {
    this.selectedForEmail = item;
  }

  onEmailSubmit(request: SendShippingEmailRequest): void {
    this.selectedForEmail = null;
    this.facade.sendEmail(request);
  }

  onEmailCancel(): void {
    this.selectedForEmail = null;
  }
}
